import shallow from 'zustand/shallow'
import { useScoreGridsStore } from './ScoreGridsStore'
import { ScoreGridsPageContent } from './ScoreGridsPageContent'

export const ScoreGridsPageTabs = (): JSX.Element => {
  const [selected] = useScoreGridsStore((state) => [state.selected], shallow)

  return (
    <>
      <ScoreGridsPageContent companyId={selected.companyId} country={selected.country} />
    </>
  )
}
